import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { appendToRmaApiUrl } from '@rma/common-ui-ng/util';
import { ProfileType } from '@rma/generic/domain/to-be-sorted';
import { RMA_DEFAULT_HTTP_OPTIONS } from '@rma/generic/util/environment';
import { RmaResponse } from '@rma/generic/util/http';
import { Observable } from 'rxjs';

import { UserNotification } from '..';

@Injectable({
  providedIn: 'root',
})
export class NotificationApiService {
  private readonly http = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  public getNextNotification(profileType: ProfileType, profileCode: string): Observable<UserNotification> {
    const uri = this.rmaApiUrl(`Notifications/${profileType}/${profileCode}/GetNextNotification`);
    return this.http.get<UserNotification>(uri, RMA_DEFAULT_HTTP_OPTIONS);
  }

  public dismissNotification(notificationId: number): Observable<RmaResponse> {
    const uri = this.rmaApiUrl('Account/UserNotificationDismissed');
    return this.http.post<RmaResponse>(uri, { UserNotificationId: notificationId }, RMA_DEFAULT_HTTP_OPTIONS);
  }

  public actionNotification(notificationId: number): Observable<RmaResponse> {
    const uri = this.rmaApiUrl('Account/UserNotificationActioned');
    return this.http.post<RmaResponse>(uri, { UserNotificationId: notificationId }, RMA_DEFAULT_HTTP_OPTIONS);
  }
}
